import { useRouteError } from 'react-router-dom';
import AppErrorScreen from './AppErrorScreen';

/** Останній рубіж роутера: падіння меню, шапки або чогось поза вмістом сторінки. */
const RouteErrorScreen = () => {
    const error = useRouteError();

    return (
        <div className="d-flex align-items-center justify-content-center min-vh-100">
            <AppErrorScreen error={error} />
        </div>
    );
};

export default RouteErrorScreen;
